import * as React from 'react';
import { memo } from 'react';
import { ISelectedProductInformation } from '../Detail';
import Configurator, { ISwatchConfig } from './Configurator';
import { useProductConfiguration } from '../../../../hooks/useProductConfiguration';
import { HTML_CLASSES } from '../../../../constants/product.constants';

interface IProps {
    config: ISwatchConfig;
    setSelectedProductInformation: (selectedProductInformation: ISelectedProductInformation) => void;
}

const ConfiguratorWrapper = (props: IProps) => {
    const { config, setSelectedProductInformation } = props;

    const {
        selectedAttributes,
        selectAttributes,
        defaultSelectedMainSwatch,
        setDefaultSelectedMainSwatch,
        secondaryAttributes,
        hasConfiguration,
        setSelectedProductInformation: hookSetSelectedProductInformation,
    } = useProductConfiguration(config, setSelectedProductInformation);

    if (!hasConfiguration || !defaultSelectedMainSwatch) {
        return <></>;
    }

    return (
        <div className={HTML_CLASSES.PRODUCT_CONFIGURATOR}>
            <Configurator
                defaultSelectedMainSwatch={defaultSelectedMainSwatch}
                setDefaultSelectedMainSwatch={setDefaultSelectedMainSwatch}
                secondaryAttributes={secondaryAttributes}
                selectedAttributes={selectedAttributes}
                selectAttributes={selectAttributes}
                attributes={config.options.attributes}
                config={config}
                setSelectedProductInformation={hookSetSelectedProductInformation}
            />
        </div>
    );
};

export default memo(ConfiguratorWrapper);
